import React, { useEffect, useState } from "react";
import CategoriesContent from "../../components/categories/content";
import RootLayout from "../layout";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";
import PageLayout from "../../components/layout/PageLayout";

const CategoriesPage = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const getCategories = async () => {
    try {
      const categoriesResponse = await httpService.get(
        getCMSApiRoute("category"),
        {
          params: {
            pageIndex: 40,
            pageNumber: 1,
            justParent: true,
          },
        }
      );

      const genresResponse = await httpService.get(getCMSApiRoute("genre"), {
        params: {
          pageIndex: 40,
          pageNumber: 1,
          justParent: true,
        },
      });

      if (
        !categoriesResponse.status === 200 ||
        !genresResponse.status === 200
      ) {
        toast.error(
          "خطای ناشناخته در دریافت اطلاعات دسته بندی و ژانر رخ داد، لطفا بعدا تلاش فرمائید"
        );
        return {
          success: false,
          categories: [],
          genres: [],
        };
      }

      return {
        categories: categoriesResponse?.data?.data?.result?.filter(x => x.status === 1),
        genres: genresResponse?.data?.data?.result?.filter(x => x.status === 1),
        success: true,
      };
    } catch (error) {
      toast.error("Error getting Category Genre data: ", error);
      return {
        success: false,
        categories: [],
        genres: [],
      };
    }
  };

  useEffect(() => {
    // Start loading - disables sidebar navigation
    dispatch(startLoading("در حال بارگذاری دسته‌بندی‌ها..."));

    getCategories().then((data) => {
      setData(data);
      setLoading(false);
      // Stop loading - re-enables sidebar navigation
      dispatch(stopLoading());
    });
  }, []);

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="category">
        {data.success && <CategoriesContent data={data} />}
      </PageLayout>
    </RootLayout>
  );
};

export default CategoriesPage;

